import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/markline'
import 'echarts/lib/component/title'

import 'zrender/lib/svg/svg'
import { addListener } from 'resize-detector'
import debounce from 'lodash/debounce'

import data from '../data/0_20_data.json'

let chartEl = document.getElementById('chartMain')

var myChart = echarts.init(
  chartEl
  // ,
  // null,
  // {
  //   renderer: 'svg'
  // }
)

// console.log(data, data[data.length-1])

let xSeries = data.pop()

let lineData = data.map(d => ({
        name: d.name,
        data: d.series.map((k,i) => [ k.t , k.cip ]),
        type: 'line',
        showSymbol: false,
        markLine: {
          animation:false,
          silent: true,
          lineStyle: {
            opacity: 0,
          },
          data: [{
            yAxis: d.series[ d.series.length-1 ].cip,
            label: {
              position: 'end',
              formatter: d.name
            },
          }]
        },
      }))

let options = {
    color: [ /* #FEE725, */"#e6ab02", "#B4DE2C", "#6DCD59", "#36B779", "#1E9E89", "#25838E", "#31688D", "#3D4A8A", "#450154"],
    grid: {
      right: 140,
      top: 35,
      left: 65,
      bottom: 50,
    },
    tooltip: {
      trigger: 'axis',
      transitionDuration: 0,
      position: (point) => [ point[0], options.grid.top ],
      formatter: (params) => {

        params.sort((a,b) => a.data[1] - b.data[1])

        let chartHeight = 500 - options.grid.top - options.grid.bottom,
          prevTop = chartHeight

        let getTop = (y) => {
          let top = -10 + chartHeight - chartHeight * y/35
          if(prevTop - top < 20) top = prevTop - 20
          prevTop = top

          return top
        }

        return `${
          params.map(p => `<div
            style="color:${ p.color };background-color:rgba(255,255,255,0.7);border-radius:0.5em;position:absolute;top:${ getTop(p.data[1]) }px;padding:0 0.5em;"
            >
            ${ p.data[1].toFixed(1) }%
            </div>`).join('')
        }`
      },
      backgroundColor: 'rgba(50,50,50,0)',
    },
    xAxis: [{
        type: 'category',
        min: 0,
        max: '15',
        splitNumber: 3,
        boundaryGap: true,
        show:false,
        axisPointer: {
          label: {
            show: true,
            formatter: '{value} years',
            color: '#1a1a1a',
            backgroundColor: 'rgba(255,255,255,0.7)',
            shadowColor: 'rgba(255,255,255,0)',
          }
        }
    },{
        type: 'value',
        boundaryGap: true,
        data: xSeries.series,
        axisTick: {
          alignWithLabel: true,
        },
        min: 0,
        max: '15',
        splitNumber: 3,
        axisPointer: {
          show:false,
        },
        position: 'bottom',
        splitLine: {
          lineStyle: {
            color: ['#ddd', '#ddd', '#ddd', '#fff']
          },
        },
        name: 'Time since autism diagnosis',
        nameLocation: 'center',
        nameGap: 30,
        axisLabel: {
          // formatter: '{value} years'
          formatter: (a) => {
            if( a > 0 ) {
              return a + ' years'
            } else {
              return 'Diagnosis'
            }
          }
        }
    }],
    yAxis: [{
        type: 'value',
        interval: 10,
        splitLine: {
          lineStyle: {
            color: ['#fff', '#ddd', '#ddd', '#ddd']
          },
        },
        axisLine: {
          show: false,
        },
        name: 'Cumulative incidence per 100 people',
        nameLocation: 'center',
        nameGap: 47,
        axisLabel: {
          formatter: '{value}%'
        }
    }],
    series: lineData
}

let placeCharts = () => {

  myChart.setOption(options)

}

let resize = () => {
  myChart.resize({
    width: chartEl.offsetWidth
  })
}

document.addEventListener('readystatechange', function() {

  if( document.readyState == 'complete' ) {

    placeCharts()

    let resizeHandler = debounce(() => {

        resize()

      }, 100, { leading: true })

    addListener(chartEl, resizeHandler)
  }

}, false)
